import React, { useCallback, useContext, useEffect } from 'react';
import { ThemeContext } from 'styled-components/native';

import CardFlag from '@components/CardFlag';
import Loading from '@components/Loading';
import ProgressBar from '@components/ProgressBar';
import Reload from '@components/Reload';
import { CardLimitInterface } from '@constants/card';
import { useFetch } from '@hooks/useFetch';
import { PriceFormat } from '@services/price';

import {
  Container,
  Header,
  HeaderCard,
  HeaderCardText,
  HeaderText,
  Limit,
  LimitBar,
  LimitText,
  LimitUsedText,
  LimitTotalText,
  ContainerCardIcon
} from './styles';

interface CardLimitProps {
  title?: string;
}

const CardLimit: React.FC<CardLimitProps> = ({ title }) => {
  const themeContext = useContext(ThemeContext);
  const { data, mutate, error, loading } = useFetch<CardLimitInterface>(
    'limits'
  );

  useEffect(() => {
    if (data) {
      const updatedData: CardLimitInterface = {
        ...data,
        percentageBarValue: (data.availableLimit * 100) / data.totalLimit
      };
      mutate(updatedData, false);
    }
  }, [data]);

  const applyColors = useCallback(() => {
    const value = data?.percentageBarValue || 0;

    if (value >= 50) return themeContext.colors.support.slot3;
    if (value >= 30 && value < 50) return themeContext.colors.base.slot5;

    return themeContext.colors.support.slot2;
  }, [data?.percentageBarValue, themeContext?.colors]);

  return (
    <Container title={title} iconName="card">
      <Reload
        message="Não foi possível carregar as informações de limite"
        onPress={() => mutate()}
        loaded={!!data?.cardDigits || !error}
      >
        <Header>
          <Loading isLoading={loading} mask="Carregando limite disponível">
            <HeaderText>Você ainda pode usar</HeaderText>
          </Loading>
          <HeaderCard>
            <Loading isLoading={loading} mask=" ">
              <ContainerCardIcon>
                {data?.flag && (
                  <CardFlag resizeMode="contain" flag={data?.flag} />
                )}
              </ContainerCardIcon>
              <HeaderCardText>**** {data?.cardDigits}</HeaderCardText>
            </Loading>
          </HeaderCard>
        </Header>
        <Limit>
          <LimitUsedText testID="limitUserText" color={applyColors}>
            <Loading isLoading={loading}>
              R$ {PriceFormat(data?.availableLimit)}
            </Loading>
          </LimitUsedText>
          <LimitBar>
            <ProgressBar value={data?.percentageBarValue} color={applyColors} />
          </LimitBar>
          <LimitText>
            limite total do seu cartão
            <Loading isLoading={loading} mask=" ">
              <LimitTotalText>
                R$ {PriceFormat(data?.totalLimit)}
              </LimitTotalText>
            </Loading>
          </LimitText>
        </Limit>
      </Reload>
    </Container>
  );
};

export default CardLimit;
